import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Handles bulk submission of ingredient forms with the current field values
export default class extends Controller {
  static values = {
    url: String,
    documentId: String,
    confirmMessage: String,
  };

  submit(event) {
    event.preventDefault();

    if (this.isSubmitting) return;

    if (this.hasConfirmMessageValue) {
      const confirmed = window.confirm(this.confirmMessageValue);
      if (!confirmed) return;
    }

    const form = document.createElement("form");
    form.method = "post";
    form.action = this.urlValue;
    form.style.display = "none";

    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    if (csrfToken) {
      form.appendChild(this.buildHiddenInput("authenticity_token", csrfToken));
    }

    form.appendChild(
      this.buildHiddenInput("document_id", this.documentIdValue ?? "")
    );

    const inputs = document.querySelectorAll("[data-bulk-field='true']");

    inputs.forEach((input) => {
      if (!input.name) return;
      if (input.disabled) return;
      if (this.isInsideHiddenContainer(input)) return;

      if (input.type === "radio" && !input.checked) return;
      if (input.type === "checkbox" && !input.checked) return;

      form.appendChild(this.buildHiddenInput(input.name, input.value));
    });

    document.body.appendChild(form);
    this.element.disabled = true;
    this.isSubmitting = true;

    Turbo.navigator.submitForm(form);

    // Clean up the temporary form after submission
    setTimeout(() => form.remove(), 1000);
  }

  buildHiddenInput(name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }

  isInsideHiddenContainer(input) {
    let element = input.parentElement;

    while (element && element !== document.body) {
      if (element.hidden) return true;

      const style = window.getComputedStyle(element);
      if (style.display === "none" || style.visibility === "hidden") {
        return true;
      }

      element = element.parentElement;
    }

    return false;
  }
}
